import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareReportsDeploymentFrequencyRoute: InvariantJiraRoute = {
	name: 'software-reports-deployment-frequency',
	path: '/jira/software/projects/:projectKey/boards/:boardId/reports/deployment-frequency',
};
